import ExamCorpusUpload from '@/components/ExamCorpus/ExamCorpusUpload';

/**
 * Trainer curriculum surface.
 *
 * Same underlying upload machinery as `/library`, but scoped to a
 * single kind: `curriculum`. The upload sheet hides its Kind toggle,
 * the taxonomy picker stops at Speciality → Level (a CDACC unit
 * standard covers every course in that level, so Module/Course don't
 * apply), the papers list only shows curriculum documents, and the
 * hero gets its own icon/gradient + copy reflecting the intent
 * (grounding the exam generator on real CDACC learning outcomes, not
 * stockpiling past papers).
 *
 * Uploading here triggers the ai_training service's learning-outcome
 * extractor — see ingestion/curriculum_extractor.py. Every subsequent
 * AI Studio generation for a course that has a curriculum here is
 * automatically grounded on the extracted LO tree.
 */
export default function CurriculumPage() {
  return (
    <ExamCorpusUpload
      kindFilter="curriculum"
      heroEyebrow="Curriculum grounding"
      heroTitle={<>Ground the model on your <em className="not-italic font-normal italic text-[#5ecdb0]">CDACC curriculum</em>.</>}
      heroSub={
        'Upload each unit standard PDF. We extract its learning outcomes, '
        + 'performance criteria and topics into a structured index, then '
        + 'the AI Studio generator uses that index to write exam questions '
        + "that test only what's actually in your curriculum."
      }
    />
  );
}
